<template>
    <b-dropdown :variant="dropdownVariant" :size="size" :disabled="disabled" right>
        <template #button-content>
            <fa icon="globe" class="mr-2"></fa> {{selected_lang}}
        </template>
        <b-dropdown-item v-for="lang in langs"
            :key="lang.id"
            @click="updateLanguage(lang.value)"
            >
            {{ lang.text }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { localize } from 'vee-validate';

export default {
    name: 'dropdown-language',
    props: {
        lang: {
            type: String,
            required: false,
            default: null
        },
        dropdownVariant: {
            type: String,
            required: false,
            default: 'red-border'
        },
        size: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

    },
    data () {
        return {
            langs: [
                { text: '한국어', value: 'ko' },
                { text: 'English', value: 'en' },
                { text: '中文', value: 'ca' }
            ]
        };
    },
    computed: {
        selected_lang () {
            if (this.lang) {
                if (this.lang === 'ko') {
                    return 'KOR';
                } else if (this.lang === 'en') {
                    return 'ENG';
                } else {
                    return 'CHN';
                }
            } else {
                if (this.$i18n.locale === 'ko') {
                    return 'KOR';
                } else if (this.$i18n.locale === 'en') {
                    return 'ENG';
                } else {
                    return 'CHN';
                }
            }
        }
    },
    methods: {
        updateLanguage (_lang) {
            if (this.lang) {
                this.$emit('updateLang', _lang);
            } else {
                this.$i18n.locale = _lang;
                document.documentElement.lang = _lang;
                try {
                    localStorage.setItem('qesg_locale', _lang);
                } catch (e) { /* 저장소 접근 불가 — 이번 세션만 유지 */ }
                // ?l= 은 저장값보다 우선(i18n.js resolveLocale)이라, 남아 있으면 새로고침 때 옛 언어로 돌아간다. 없는 화면엔 붙이지 않는다.
                // 사용자 조작이지만 replace — 화면 언어는 주소 변화를 다시 읽지 않아 push 하면 뒤로가기 때 주소와 화면 언어가 어긋난다
                const _query_l = this.$route && this.$route.query.l;
                if (_query_l && _query_l !== _lang) {
                    const { l: _old_l, ...query } = this.$route.query;
                    if (_lang !== (process.env.VUE_APP_I18N_LOCALE || 'ko')) query.l = _lang; // 기본 언어는 키 생략
                    this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash }).catch(() => {});
                }
            }
            localize(this.$i18n.locale);
        }
    }
};
</script>

<style>

</style>
